export const UNIX_START_OF_TIME = new Date(1970, 0, 1, 0, 0, 0);
